import { LoanStatus2, SubmitApplicationDecision } from '@servicetitan/financing-api-client';

const APPROVED_STATUSES = new Set<LoanStatus2>([LoanStatus2.Approved, LoanStatus2.Prequalified]);

const PENDING_STATUSES = new Set<LoanStatus2>([
    LoanStatus2.Submitted,
    LoanStatus2.AboutToSubmit,
    LoanStatus2.PrequalificationPending,
]);

export const mapFinancingPrequalStatusToDecision = (
    status: LoanStatus2 | null | undefined,
): SubmitApplicationDecision => {
    if (status == null) {
        return SubmitApplicationDecision.Error;
    }

    if (APPROVED_STATUSES.has(status)) {
        return SubmitApplicationDecision.Approved;
    }

    if (status === LoanStatus2.Declined) {
        return SubmitApplicationDecision.Declined;
    }

    if (status === LoanStatus2.Review) {
        return SubmitApplicationDecision.Review;
    }

    if (PENDING_STATUSES.has(status)) {
        return SubmitApplicationDecision.Submitted;
    }

    if (
        status === LoanStatus2.Error ||
        status === LoanStatus2.Cancelled ||
        status === LoanStatus2.Invalid
    ) {
        return SubmitApplicationDecision.Error;
    }

    return SubmitApplicationDecision.Error;
};

export const isFinancingPrequalApprovedStatus = (status: LoanStatus2 | null | undefined): boolean =>
    status != null && APPROVED_STATUSES.has(status);
